module.exports = __webpack_public_path__ + "static/media/HCMM731.817f8ce6.jpg";